(function () {
    'use strict';

    angular
        .module('dialog-manager')
        .factory('DialogManager', DialogManager);

    const avoidCPWS = ['bubbles', 'context', 'angular_id', 'innerHTML', '$root', '$parent', '$promise', '$resolved', 'window', '__proto__'];

    function DialogManager(lodash, $q, ModalService, $rootScope) {
        const dialogsRef = [];
        return {
            init: (dialogId, data) => {
                return showAndRegisterDialog(dialogId, data);
            },
            get: (dialogId) => {
                const dialogRefObj = findDialog(dialogId);
                return (dialogRefObj) ? dialogRefObj.modal : null;
            },
            getAll: () => {
                return dialogsRef;
            },
            getData: (dialogId, dataPath) => {
                const dialogRefObject = findDialog(dialogId);
                if (!dialogRefObject) return false;
                return lodash.get(dialogRefObject.modal.controller, dataPath, false);
            },
            hasDialog: (dialogId) => {
                const dialogRefObj = findDialog(dialogId);
                return !!dialogRefObj;
            },
            setData: (dialogId, dataPath, value) => {
                const dialogRefObject = findDialog(dialogId);
                if (!dialogRefObject) return false;
                return lodash.set(dialogRefObject.modal.controller, dataPath, value);
            },
            setOption: (dialogId, key, value) => {
                var dialog = findDialog(dialogId);
                lodash.set(dialog.modal, key, value);
            },
            close: (dialogId) => {
                return closeDialog(dialogId);
            },
            destroy: (dialogId) => {
                return closeDialog(dialogId);
            },
            destroyAll: () => {
                return closeAll();
            },
            closeAll: () => {
                return closeAll();
            }
        };

        function findDialog(dialogId) {
            return lodash.find(dialogsRef, {dialogId: dialogId});
        }

        function closeDialog(dialogId) {
            return $q.when(function () {
                const dialogRefObj = findDialog(dialogId);
                if (dialogRefObj) {
                    dialogRefObj.modal.controller.dismiss();
                    return dialogRefObj.closed;
                }
                return false;
            }());
        }

        function closeAll() {
            return $q.when(dialogsRef.map(function (dialog) {
                return closeDialog(dialog.dialogId);
            }));
        }

        function showAndRegisterDialog(dialogId, data) {
            var dialog_options = {};
            try {
                var dialog_option_temp = lodash.get(data, 'dialog_options', {});
                dialog_options = cleanDialogOptions(dialog_option_temp);
            } catch (e) {
                console.log(e);
            }
            const showModalOptions = {
                controller: data.controller,
                controllerAs: 'vm',
                appendElement: angular.element('.modal-wrapper'),
                inputs: {
                    dialogId: dialogId,
                    dialogOptions: angular.copy(dialog_options)
                }
            };

            if (lodash.has(data, 'template')) {
                showModalOptions.template = data.template;
            }

            if (lodash.has(data, 'templateUrl')) {
                showModalOptions.templateUrl = data.templateUrl;
            }

            return ModalService.showModal(showModalOptions).then(function (modal) {
                if (lodash.has(data, 'trigger.init')) {
                    $rootScope.$broadcast(data.trigger.init, modal);
                }
                dialogManipulatePace(true);
                modal.element.show();

                var modals = $('.modal');
                if (modals.length > 1) processOffset(modals);

                modal.close.then(function (res) {
                    if (lodash.has(data, 'trigger.closing')) {
                        $rootScope.$broadcast(data.trigger.closing, data.dialog_options.actionData);
                    }
                });
                modal.closed.then(function (res) {
                    if (dialogsRef.length <= 1) {
                        dialogManipulatePace(false);
                    }
                    const refId = lodash.findIndex(dialogsRef, {dialogId: dialogId});
                    dialogsRef.splice(refId, 1);

                    if (res !== false) {
                        if (lodash.has(data, 'trigger.completed')) {
                            $rootScope.$broadcast(data.trigger.completed, data.dialog_options.actionData);
                        }
                    }

                    if (lodash.has(data, 'trigger.closed')) {
                        $rootScope.$broadcast(data.trigger.closed, data.dialog_options.actionData);
                    }
                    return res;
                });

                const dialogRefObj = {
                    dialogId: dialogId,
                    modal: modal
                };
                dialogsRef.push(dialogRefObj);
                return dialogRefObj;
            });
        }

        function processOffset($modals) {
            var top = 15;
            var left = 15;
            $modals.each(function (index) {
                if (index >= 1) {
                    $(this).children('.modal-dialog').css({
                        top: top + 'px',
                        left: left + 'px'
                    });
                    top += 5;
                    left += 5;
                }
            });
        }

        function dialogManipulatePace(state) {
            if (state) {
                angular.element('body').addClass('dialog-active');
            } else {
                angular.element('body').removeClass('dialog-active');
            }
        }


        function cleanDialogOptions(data) {
            if (['string', 'number'].indexOf(typeof data) >= 0) {
                return data;
            }
            if (data === null) {
                return data;
            }
            if (data instanceof Array) {
                console.log('arrayData', data);
                return data;
            }
            const result = {};

            lodash.forIn(data, function (value, key) {
                try {
                    switch (typeof value) {
                        case 'string':
                        case 'number':
                        case 'boolean': {
                            // string and numbers are safe.
                            result[key] = value;
                            break;
                        }
                        case 'object': {
                            if (value === null) {
                                result[key] = value;
                                break;
                            }
                            if (value instanceof jQuery.Event) {
                                break;
                            }
                            if (value instanceof jQuery.fn.init) {
                                break;
                            }
                            if (value instanceof Array) {
                                // preparing or temp valResult
                                var valResult = [];
                                lodash.forEach(value, function (val) {
                                    // check if the cpws objects exists
                                    const exists = avoidCPWS.reduce(function (r, cpwsField) {
                                        if (r === true) return r;
                                        return lodash.has(val, cpwsField);
                                    }, false);
                                    if (!exists) {
                                        // set the value to
                                        const _d1 = cleanDialogOptions(val);
                                        valResult.push(_d1);
                                    }
                                });
                                result[key] = valResult;
                            } else {
                                const exists = avoidCPWS.reduce(function (r, cpwsField) {
                                    if (r === true) return r;
                                    return lodash.has(value, cpwsField);
                                }, false);
                                if (!exists) {
                                    const _d1 = cleanDialogOptions(value);
                                    if (!lodash.isEmpty(_d1)) {
                                        result[key] = _d1;
                                    }
                                }
                            }
                            break;
                        }
                        default: {
                            break;
                        }
                    }
                } catch (e) {
                    console.log({key, value}, e);
                    throw e;
                }

            });
            return result;
        }
    }
})();